/**
 * Configuração de versão para o Prodgy Front
 * Gerencia informações de versão e build da aplicação
 */

interface BuildInfo {
  version: string;
  buildNumber: string;
  buildDate: string;
  environment: string;
}

// Importa a versão do package.json via configuração do Vite
// A ordem de prioridade de busca da versão é:
// 1. VITE_PACKAGE_VERSION (definido no vite.config.ts a partir do package.json)
// 2. VITE_APP_VERSION (definido durante o build do container/pipeline)
// 3. Qualquer valor que já esteja definido no package.json
const packageVersion = import.meta.env.VITE_PACKAGE_VERSION || import.meta.env.VITE_APP_VERSION;

// Log para debug da versão
console.debug('Versão obtida:', { 
  VITE_PACKAGE_VERSION: import.meta.env.VITE_PACKAGE_VERSION,
  VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
  packageVersion
});

// Configuração para o ambiente atual
const defaultBuildInfo: BuildInfo = {
  version: packageVersion,
  buildNumber: import.meta.env.VITE_BUILD_NUMBER || 'dev',
  buildDate: import.meta.env.VITE_BUILD_DATE || new Date().toISOString(),
  environment: import.meta.env.MODE || 'development'
};

/**
 * Retorna as informações de build e versão da aplicação
 */
export const getBuildInfo = (): BuildInfo => {
  return defaultBuildInfo;
};
